import { Button, Card } from '@mui/material';
import { Column, Row } from 'Components/Grid';
import { ReactComponent as OpenLinkIcon } from './../../../../assets/open_link.svg';

export const TagGtmContent = () => {
  return (
    <>
      <Row>
        <Column
          xs={12}
          flex
          style={{
            alignItems: 'center',
            marginBlock: '16px',
          }}
        >
          <div
            style={{
              width: '100%',
              height: '1px',
              backgroundColor: '#d1d5db',
              border: '1px solid #e5e7eb',
            }}
          ></div>
          <span style={{ fontSize: '14px', fontWeight: '400', marginInline: '12px', textWrap: 'nowrap' }}>
            Google Tag Manager
          </span>
          <div
            style={{
              width: '100%',
              height: '1px',
              backgroundColor: '#d1d5db',
              border: '1px solid #e5e7eb',
            }}
          ></div>
        </Column>
      </Row>
      <Row>
        <Column xs={12}>
          <Card
            sx={{
              backgroundColor: '#f9fafb',
              padding: '12px 24px',
              boxShadow: 'none',
              border: '1px solid #ccc',
            }}
          >
            <Row>
              <Column xs={11}>
                <span style={{ fontSize: '14px' }}>
                  Siga o passo a passo incluso na página do&nbsp;
                  <a
                    style={{ textDecoration: 'none', color: '#1976d2' }}
                    href="https://support.vofficer.io/hc/pt-br/articles/23322149914260-Integração-do-Banner-de-Cookies-com-o-Google-Tag-Manager"
                    rel="noreferrer"
                    target="_blank"
                  >
                    link a seguir
                  </a>
                  .
                </span>
              </Column>
              <Column xs={1} className="pr-0" style={{ display: 'flex', justifyContent: 'end' }}>
                <Button
                  variant="link"
                  startIcon={<OpenLinkIcon width="22px" height="24px" style={{ padding: '2px' }} />}
                  size="small"
                  sx={{ padding: '6px', minWidth: '32px' }}
                  href="https://support.vofficer.io/hc/pt-br/articles/23322149914260-Integração-do-Banner-de-Cookies-com-o-Google-Tag-Manager"
                  rel="noreferrer"
                  target="_blank"
                ></Button>
              </Column>
            </Row>
          </Card>
        </Column>
      </Row>
    </>
  );
};
